export const localizedPaths = {
  home: { tr: "/", en: "/" },
  about: { tr: "/hakkimizda", en: "/about" },
  contact: { tr: "/iletisim", en: "/contact" },
  product: { tr: "/ehliyet-siniflarimiz", en: "/license-classes" },
  registration: { tr: "/kayit-belgeleri", en: "/registration-documents" },
  faq: { tr: "/sss", en: "/faq" },
  usefulLinks: { tr: "/faydali-linkler", en: "/useful-links" },
  vehicles: { tr: "/araclarimiz", en: "/vehicles" },
  a1: { tr: "/a1-ehliyet", en: "/a1-license" },
  a2: { tr: "/a2-ehliyet", en: "/a2-license" },
  bManual: { tr: "/b-manuel", en: "/manual-b-license" },
  bAutomatic: { tr: "/b-otomatik", en: "/automatic-b-license" },
};

export const routeMeta = {
  home: {
    tr: {
      title: "Nova Sürücü Kursu | Bursa Sürücü Kursu ve Ehliyet Eğitimi",
      description:
        "Nova Sürücü Kursu ile A1, A2, B manuel ve B otomatik ehliyet eğitimleri hakkında bilgi alın. Kayıt, sınav süreci ve faydalı bağlantılar tek yerde.",
    },
    en: {
      title: "Nova Driving School | Driving Courses and License Training in Bursa",
      description:
        "Explore A1, A2, B manual and B automatic license training at Nova Driving School. Registration, exam process and useful links are all in one place.",
    },
  },
  about: {
    tr: {
      title: "Hakkımızda | Nova Sürücü Kursu",
      description:
        "Nova Sürücü Kursu hakkında bilgi alın. Misyonumuz, vizyonumuz ve sürücü eğitimine yaklaşımımızı inceleyin.",
    },
    en: {
      title: "About Us | Nova Driving School",
      description:
        "Learn more about Nova Driving School, our mission, our vision and our approach to modern driver education.",
    },
  },
  contact: {
    tr: {
      title: "İletişim | Nova Sürücü Kursu",
      description:
        "Nova Sürücü Kursu iletişim bilgileri, adres, telefon, WhatsApp ve iletişim formu üzerinden bize kolayca ulaşın.",
    },
    en: {
      title: "Contact | Nova Driving School",
      description:
        "Reach Nova Driving School easily through our contact details, address, phone, WhatsApp and contact form.",
    },
  },
  product: {
    tr: {
      title: "Ehliyet Sınıflarımız | Nova Sürücü Kursu",
      description:
        "A1, A2, B manuel ve B otomatik ehliyet sınıflarımızı karşılaştırın. Size uygun sürücü belgesi sınıfını kolayca seçin.",
    },
    en: {
      title: "License Classes | Nova Driving School",
      description:
        "Compare our A1, A2, B manual and B automatic driving license classes and choose the one that fits your goals.",
    },
  },
  registration: {
    tr: {
      title: "Kayıt İçin Gerekli Belgeler | Nova Sürücü Kursu",
      description:
        "Sürücü kursu kaydı için gereken belgeleri, sağlık raporu ödeme bilgisini ve başvuru sürecini adım adım inceleyin.",
    },
    en: {
      title: "Registration Documents | Nova Driving School",
      description:
        "Review the required registration documents, health report payment details and the application process step by step.",
    },
  },
  faq: {
    tr: {
      title: "Sıkça Sorulan Sorular | Nova Sürücü Kursu",
      description:
        "Ehliyet kaydı, dersler, sınav süreci ve belge şartları hakkında en sık sorulan soruların yanıtlarını bulun.",
    },
    en: {
      title: "Frequently Asked Questions | Nova Driving School",
      description:
        "Find answers to the most common questions about registration, lessons, exams and required documents.",
    },
  },
  usefulLinks: {
    tr: {
      title: "Faydalı Linkler | Nova Sürücü Kursu",
      description:
        "E-Devlet, ödeme sistemi, ehliyet randevu ve resmi bilgilendirme bağlantılarına tek sayfadan ulaşın.",
    },
    en: {
      title: "Useful Links | Nova Driving School",
      description:
        "Access e-Government, payment system, driver appointment and official information links from one page.",
    },
  },
  vehicles: {
    tr: {
      title: "Araçlarımız | Nova Sürücü Kursu",
      description:
        "A1, A2, B manuel ve B otomatik eğitim araçlarımızı inceleyin. Modern ve sınıfa uygun filomuzu keşfedin.",
    },
    en: {
      title: "Our Vehicles | Nova Driving School",
      description:
        "Explore our A1, A2, B manual and B automatic training vehicles and discover our modern class-appropriate fleet.",
    },
  },
  a1: {
    tr: {
      title: "A1 Ehliyet Rehberi | Nova Sürücü Kursu",
      description:
        "A1 ehliyet yaş şartı, sınav aşamaları, gerekli belgeler ve kullanım kapsamını ayrıntılı rehberimizde inceleyin.",
    },
    en: {
      title: "A1 License Guide | Nova Driving School",
      description:
        "Review the A1 license age requirement, exam stages, required documents and vehicle scope in our detailed guide.",
    },
  },
  a2: {
    tr: {
      title: "A2 Ehliyet Rehberi | Nova Sürücü Kursu",
      description:
        "A2 ehliyet kapsamı, başvuru şartları, sınav süreci ve gerekli belgeler hakkında detaylı bilgi alın.",
    },
    en: {
      title: "A2 License Guide | Nova Driving School",
      description:
        "Get detailed information about A2 license scope, requirements, exam process and required documents.",
    },
  },
  bManual: {
    tr: {
      title: "B Manuel Ehliyet Rehberi | Nova Sürücü Kursu",
      description:
        "B manuel ehliyetin kapsamını, başvuru şartlarını, sınav sürecini ve belge listesini bu sayfada inceleyin.",
    },
    en: {
      title: "Manual B License Guide | Nova Driving School",
      description:
        "Review the scope, application requirements, exam stages and document list for the manual B license.",
    },
  },
  bAutomatic: {
    tr: {
      title: "B Otomatik Ehliyet Rehberi | Nova Sürücü Kursu",
      description:
        "B otomatik ehliyetin kullanım kapsamı, belge şartları ve sınav süreci hakkında güncel bilgi alın.",
    },
    en: {
      title: "Automatic B License Guide | Nova Driving School",
      description:
        "Get up-to-date information about the automatic B license scope, document requirements and exam process.",
    },
  },
};

export const pathToMetaKey = {
  "/": "home",
  "/hakkimizda": "about",
  "/about": "about",
  "/iletisim": "contact",
  "/contact": "contact",
  "/ehliyet-siniflarimiz": "product",
  "/license-classes": "product",
  "/kayit-belgeleri": "registration",
  "/registration-documents": "registration",
  "/sss": "faq",
  "/faq": "faq",
  "/faydali-linkler": "usefulLinks",
  "/useful-links": "usefulLinks",
  "/araclarimiz": "vehicles",
  "/vehicles": "vehicles",
  "/a1-ehliyet": "a1",
  "/a1-ehliyet-rehberi": "a1",
  "/a1-license": "a1",
  "/a2-ehliyet": "a2",
  "/a2-ehliyet-rehberi": "a2",
  "/a2-license": "a2",
  "/b-manuel": "bManual",
  "/b-manuel-ehliyet-rehberi": "bManual",
  "/manual-b-license": "bManual",
  "/b-otomatik": "bAutomatic",
  "/b-otomatik-ehliyet-rehberi": "bAutomatic",
  "/automatic-b-license": "bAutomatic",
};

export function getLocalizedPath(key, language) {
  const normalizedLanguage = language === "en" ? "en" : "tr";
  return localizedPaths[key]?.[normalizedLanguage] || "/";
}

